export default __webpack_public_path__ + "static/media/arrow.5a8741cc.svg";